import { VirtualCursorList } from '../../ui-kit/VirtualCursorList'
import type { WindowedCursorListRange } from '../../../hooks/useWindowedCursorList'
import type { TUsersListResponse } from '../../../api/types/users'
import { UserItem } from '../UserItem'

type UsersListProps = {
  users: TUsersListResponse
  firstItemIndex?: number
  hasMore?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
  onStartReached?: () => void
  onRangeChanged?: (range: WindowedCursorListRange) => void
}

export const UsersList = ({
  users,
  firstItemIndex,
  hasMore,
  isLoadingMore,
  onLoadMore,
  onStartReached,
  onRangeChanged,
}: UsersListProps) => {
  return (
    <VirtualCursorList
      items={users}
      firstItemIndex={firstItemIndex}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={onLoadMore}
      onStartReached={onStartReached}
      onRangeChanged={onRangeChanged}
      getItemKey={(_index, user) => user.id}
      emptyMessage="Нет пользователей для отображения"
      itemContent={(_index, user) => <UserItem user={user} />}
    />
  )
}
